import { Outlet } from 'react-router-dom';
import BottomNav from '../../components/BottomNav/BottomNav';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import './AdminLayout.css';

function AdminLayout() {
    return (
        <div className="admin-layout">
            <Sidebar />
            <div className="admin-layout__main">
                <Header />
                <main className="admin-layout__content">
                    <Outlet />
                </main>
            </div>
            <BottomNav />
        </div>
    );
}

export default AdminLayout;
